export default __webpack_public_path__ + "src/assets/neutralIndicator.b38f50fbcadf1403fc3aeaea306573fb.svg";